import classNames from 'classnames';
import { PropsWithChildren } from 'react';

interface SkeletonLoaderProps extends PropsWithChildren {
  loading?: boolean;
  className?: string;
  w?: number;
  h?: number;
}

function SkeletonLoader({ loading = true, w = 80, h, className, children }: SkeletonLoaderProps) {
  if (loading) {
    return (
      <div
        className={classNames('w-full, pulse h-full min-h-5', 'rounded-md', className)}
        style={{
          width: w ? w + 'px' : undefined,
          height: h ? h + 'px' : undefined,
        }}
      />
    );
  }
  return <>{children}</>;
}

export default SkeletonLoader;
